import { Col, Row } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import AppContext from "../../../context/app/context";
import Form from "../../form-components/from";
import { INITIAL_PAGE } from "../../../utils/helpers/constants";
import FieldBuilder from "../../form-components/field-builder";
import { getUserStatus } from "../../../models/user/enum";
import { getBannerType } from "../../../models/banner/enum";
import BannerTrademarkContext from "../../../context/banner-trademark/context";
import { ITrademarkLight } from "../../../models/trademark-manager/response";
import EndPoints from "../../../services/end-points";
import { useLocation } from "react-router-dom";
import { addSearchToURL, filtersToQueryString, getFiltersFromURL, getKeywordFromURL } from "../../../utils/helpers/url";
interface IProps { }

const BannerTrademarkFilter: React.FC<IProps> = () => {
  const { t } = useTranslation();
  const { actions, query } = useContext(BannerTrademarkContext);
  const { direction } = useContext(AppContext);
  const [trademarks, setTrademarks] = useState<ITrademarkLight[]>([]);
  const [trademarksLoading, setTrademarksLoading] = useState<boolean>(false);
  const statuses = [1, 2];

  const location = useLocation();
  const [initialValues, setInitialValues] = useState<Record<string, any>>({});

  useEffect(() => {
    const filters = getFiltersFromURL();

    const initialValuesObj = {};
    filters.forEach((f) => {
      initialValuesObj[f.name] = f.value;
    });

    setInitialValues(initialValuesObj);
  }, [location.search]); useEffect(() => {
    const getTradmarks = async () => {
      try {
        const { data } = await EndPoints.trademark.getAllTrademark({
          light: true,
          perPage: -1,
        });
        setTrademarks(data.data);
        setTrademarksLoading(false);
      } catch (error) {
      } finally {
        setTrademarksLoading(false);
      }
    };
    getTradmarks();
  }, [direction]);

  return (
    <Form
      formId="trademark-banner-filter"
      defaultValues={initialValues}
      onSubmit={(data) => {
        const keyword = getKeywordFromURL();
        const filter: any = {
          page: INITIAL_PAGE,
          perPage: query?.perPage,
          keyword: keyword,
          filters: [
            data?.status
              ? {
                name: "status",
                value: data.status,
                operation: "eq",
              }
              : undefined,
            data?.type
              ? {
                name: "type",
                value: data.type,
                operation: "eq",
              }
              : undefined,
            data?.category_id
              ? {
                name: "category_id",
                value: data.category_id,
                operation: "eq",
              }
              : undefined,
          ].filter((f) => f),
        };
        const queryString = filtersToQueryString(filter.filters);
        window.history.replaceState(null, "", `?${queryString}`);
        addSearchToURL(keyword);
        actions.setQuery(filter);
      }}
    >
      <Row justify={"start"} gutter={[10, 0]}>
        <Col xs={24} sm={24} md={8} lg={8} xl={8} xxl={8}>
          <FieldBuilder
            name="status"
            label={`${t("status")}`}
            width="large"
            input={{
              type: "select",
              options: statuses.map((status, index) => {
                return {
                  label: t(getUserStatus(status) as string),
                  value: status as number,
                };
              }),
            }}
          />
        </Col>
        <Col xs={24} sm={24} md={8} lg={8} xl={8} xxl={8}>
          <FieldBuilder
            name="type"
            label={`${t("type")}`}
            width="large"
            input={{
              type: "select",
              options: [1, 2, 3, 4, 5, 6].map((status, index) => {
                return {
                  label: t(getBannerType(status) as string),
                  value: status as number,
                };
              }),
            }}
          />
        </Col>
        <Col xs={24} sm={24} md={8} lg={8} xl={8} xxl={8}>
          <FieldBuilder
            name="trademarkId"
            label={`${t("trademark")}`}
            width="large"
            input={{
              type: "select",
              loading: trademarksLoading,
              allowSearch: true,
              options: trademarks?.map((store, index) => {
                return {
                  key: index,
                  label: store.name,
                  value: store.id,
                };
              }),
            }}
          />
        </Col>
      </Row>
    </Form>
  );
};

export default BannerTrademarkFilter;
